export enum BulkCreateStatus {
    READY = 'READY',
    ATTENTION = 'ATTENTION',
    SKIP = 'SKIP'
}

export interface ProjectPreview {
    companyId: string;
    companyName: string;
    companyLabel?: string;
    status: BulkCreateStatus;
    reason?: string;
    nextProjectStartDate?: string;
    nextProjectEndDate?: string;
    targetYear?: string;
    previousProjectEndDate?: string;
}

export interface BulkCreateFinancialYearPreviewDto {
    previews: ProjectPreview[];
    readyCount: number;
    attentionCount: number;
    skipCount: number;
}
